import React from "react";

const NotFound = () => {
  return (
    <div>
      <h2 className="text-6xl text-red-600">Sorry!Page not available!!</h2>
      <img
        className="w-2/4 mx-auto my-6"
        src="https://cdn.mos.cms.futurecdn.net/PuXipAW3AXUzUJ4uYyxPKC-1200-80.jpg"
        alt=""
      />
    </div>
  );
};

export default NotFound;
